// removed by extract-text-webpack-plugin
module.exports = {"clusterWrapper":"clusterWrapper_2bL","cluster":"cluster_IDK","clusterHeading":"clusterHeading_u6C"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/cluster-page/cluster-page.scss
// module id = 625
// module chunks = 0 1